<template>
  <div class="col-md-12">
    <div class="w-block" style="padding: 2px;">
      <el-date-picker v-model="month" type="month" placeholder="选择月" @change="getList">
      </el-date-picker>
    </div>
    <wgrid :data="grid.ls" v-loading="grid.loading" :pageShow="false">
      <el-table-column prop="TitleStart" label="日期" width="180" align="center"></el-table-column>
      <el-table-column prop="AllCount" label="总计" align="center"></el-table-column>
      <el-table-column label="正常" align="center">
        <template slot-scope="scope">
          <span :style="{color: scope.row.NomalCount>0?'#3bb667':''}">{{ scope.row.NomalCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ErrCount" label="异常" align="center">
        <template slot-scope="scope">
          <span :style="{color: scope.row.ErrCount>0?'red':''}">{{ scope.row.ErrCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnCheckCount" label="未检" align="center"></el-table-column>
      <el-table-column type="expand" label="详情" align="center" width="80px">
        <template slot-scope="{row}">
          <el-table border ref="details" :data="row.Details"
                    style="width: 98%;margin:0 auto;">
            <el-table-column prop="ConfigName" label="项目" align="center"></el-table-column>
            <el-table-column prop="Loca" label="位置" align="center"></el-table-column>
            <el-table-column prop="CheckCount" label="检测次数" align="center"></el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="{row}">
                <span v-if="row.ConfigState=='正常'" style="color: #3bb667">{{ row.ConfigState }}</span>
                <span v-if="row.ConfigState=='异常'" style="color: red">{{ row.ConfigState }}</span>
                <span v-if="row.ConfigState=='未检'">{{ row.ConfigState }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ErrorCount" label="异常次数" align="center"></el-table-column>
            <el-table-column label="详情" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="getDetail(row,scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="130px">
        <template slot-scope="{row}">
          <el-button type="success" size="mini" icon="el-icon-plus" @click="supplement(row)">补录记录</el-button>
        </template>
      </el-table-column>
    </wgrid>
    <el-dialog :visible="showDetail" :before-close="handleClose">
      <span slot="title">查看</span>
      <el-form v-for="(row,index) in rows" :key="index" :model="row" label-position="left">
        <div style="margin-bottom: 22px">
          <span style="color: #1492ff">【{{ row.Safe_Class_Name }}】</span>
          <span style="font-weight: bold;margin-right: 10px">{{ row.CONF_NAME }}</span>
          <el-tag v-if="row.RET_TXT=='正常'" type="success">{{ row.RET_TXT }}</el-tag>
          <el-tag v-if="row.RET_TXT=='异常'" type="danger">{{ row.RET_TXT }}</el-tag>
        </div>
        <el-form-item label="巡检位置：">
          <span>{{ row.Loca }}</span>
        </el-form-item>
        <el-form-item label="巡检人员：">
          <span>{{ row.SUB_NAME }}</span>
        </el-form-item>
        <el-form-item label="巡检时间：">
          <span>{{ row.CREATED_DT| datetime('YYYY-MM-DD HH:mm') }}</span>
        </el-form-item>
        <el-form-item label="巡检内容：">
          <div>{{ row.DESCRIPTION }}</div>
          <div>{{ row.NORMAL_MESSAGE }}</div>
        </el-form-item>
        <el-form-item label="相关照片：">
          <div>
            <img v-if="row.PIC_URL" class="img" :src="row.PIC_URL" alt="" @click="imgShow=true">
            <span v-else>无</span>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Wgrid from "@/components/wgrid";
import {getMonthRange} from "@/util";
import Swal from "sweetalert2";

export default {
  name: "AF",
  components: {Wgrid},
  props: ['type'],
  data() {
    return {
      grid: {
        ls: [],
        loading: false
      },
      month: '',
      rows: [],
      showDetail: false,
      imgShow: false,
    }
  },
  watch: {
    type() {
      this.getList();
    }
  },
  mounted() {

  },
  methods: {
    getList() {
      let self = this;
      this.grid.loading = true;
      this.whale.remote.getResult({
        url: "api/School/SAFE/RecApi/GetAllData",
        data: {
          Safe_Class_Id: self.type.ID,
          Safe_Class_Name: self.type.Safe_Class_Name,
          DTS: getMonthRange(this.month).DTS,
          DTE: getMonthRange(this.month).DTE,
        },
        completed: function (its) {
          self.grid.loading = false;
          self.grid.ls = its.DATA;
        },
        failure: function (err) {
          Swal.fire({
            title: "出错啦",
            text: err,
            icon: "error",
            cancelButtonText: "关闭",
            showCancelButton: true,
            showConfirmButton: false,
          });
          self.grid.loading = false;
          self.grid.ls = [];
        }
      })
    },
    getDetail(row, item) {
      let self = this;
      this.whale.remote.getResult({
        url: "api/School/SAFE/RecApi/GetList",
        data: {DTS: row.TitleStart, DTE: row.TitleEnd, CONF_ID: item.ConfigId, PAGE_SIZE: 100},
        completed: function (its) {
          if (its.DATA.ITEMS.length == 0) {
            self.$message({type: 'warning', message: '暂无数据'});
            return;
          }
          self.showDetail = true;
          self.rows = its.DATA.ITEMS;
        },
      })
    },
    supplement(row) {
      const date = row.TitleStart;
      const period = row.TitleEnd && row.TitleEnd !== row.TitleStart ? `${row.TitleStart} 至 ${row.TitleEnd}` : date;
      this.$confirm(`将自动补录 ${period} 周期内尚未巡检的${this.type.Safe_Class_Name}项目，无需填写其他数据。是否继续？`, `补录${this.type.Safe_Class_Name}记录`, {
        confirmButtonText: "确认补录",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.grid.loading = true;
        this.whale.remote.getResult({
          url: "api/School/SAFE/RecApi/SupplementData",
          data: { DATE: date, SAFE_CLASS_ID: this.type.ID },
          completed: response => {
            const result = response.DATA || {};
            if ((result.SupplementCount || 0) > 0) {
              this.$message.success(`${result.Date} 补录完成，共补录 ${result.SupplementCount} 条记录`);
            } else {
              this.$message.info(`${result.Date || date} 没有需要补录的${this.type.Safe_Class_Name}项目`);
            }
            this.getList();
          },
          finally: () => { this.grid.loading = false; }
        });
      }).catch(() => {});
    },
    handleClose() {
      this.showDetail = false;
    }
  }
}
</script>

<style scoped>

</style>
